import React, { useState, useEffect } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import { showErrorMessage } from '../../utils';
import css from './index.module.scss';
import { message } from '@/components/UI/Message';
import NextImage from '@/components/NextImage';
import Button from '@/components/UI/Button';
import { checkRewardDraw, rewardDraw } from '@/service';
import { useGlobal } from '@/utils/useGlobal';
import { euLocaleList } from '@/constants/appreciationDay';
import { signupCookie } from '@/utils/cookies/signupCookie';

interface Prizes {
    drawId: React.Key; // 抽奖活动ID
    id: React.Key;
    isDisplayName: boolean;
    prizeId: React.Key; // 奖品ID
    prizeName: string;
    tips: string;
    type: 'NOTHING' | 'INTEGRAL' | 'COUPONS' | 'FREE_PRODUCTS' | 'THIRD_COUPONS';
    iconUrl?: string;
    isDisplayIcon?: boolean;
}
// 添加卡片状态
type IFlopItem = {
    id: React.Key;
    title: string;
    imgUrl?: string;
    checked?: boolean; // 是否选中
    flip?: boolean; //是否翻转
    x: number; //
    y: number;
    type?: string;
};

interface FlopGameProps {
    isLogin: boolean;
    prizes: Prizes[];
    disabled?: boolean;
    drawInfo?: any;
    onStart: () => void;
    onEnd?: (winnerPrize?: any) => void;
    onCheckError?: () => void;
    pathUrl?: string;
}

const FlopGame: React.FC<FlopGameProps> = ({ isLogin, prizes, disabled = false, drawInfo, onStart, onEnd, onCheckError, pathUrl }) => {
    const { useRouter, isMobile, useLang, gtm } = useGlobal();
    const { t } = useLang('ecocredits');
    const router = useRouter();
    const { locale } = router;
    const [status, setStatus] = useState(1); // 1 准备 2 抽奖 3 结束
    const [loading, setLoading] = useState(false);
    const [flopList, setFlopList] = useState<IFlopItem[]>([]);
    const [awardData, setAwardData] = useState<Prizes | null>(null);
    const offsetY = isMobile ? 120 : 256;
    const offsetX = isMobile ? 110 : 250;
    const isEu = euLocaleList.includes(locale);

    const initFlopList = () => {
        const initFlopArr = prizes.map((item, index) => {
            const flopItem = {
                id: item.id as string,
                checked: false,
                flip: false,
                // title: '',
                title: item.prizeName,
                imgUrl: '',
                x: 0,
                y: 0,

                // 调试
                // item.title = item.isDisplayName ? item.prizeName : '';
                // imgUrl: item.isDisplayIcon ? item.iconUrl : '',
                // checked: true,
                // flip: false,
                // type: item.type,
            };
            const row = Math.ceil((index + 1) / 3);
            const column = (index + 1) % 3;
            // y偏移量
            if (row === 1) {
                flopItem.y = offsetY;
            }
            if (row === 2) {
                flopItem.y = 0;
            }
            // x偏移量
            if (column === 1) {
                flopItem.x = offsetX;
            } else if (column === 2) {
                flopItem.x = 0;
            } else {
                flopItem.x = -offsetX;
            }
            return flopItem;
        });
        // console.log(initFlopArr);
        // initFlopArr.map((item: any) => {
        //     item.x = 0;
        //     item.y = rowsModal === 1 ? offsetY[rowsModal] : 0;
        // });
        setFlopList(initFlopArr);
    };

    const handleSettlement = (targetId: React.Key, targetIndex: number) =>
        new Promise((resolve, _reject) => {
            const targetPrize = prizes.find((item) => item.id === targetId) as Prizes; // 抽中的 因为返回的对象属性不全
            const otherPrizes = prizes.filter((item) => item.id !== targetId); // 未抽中的其他奖品
            let otherPrizeIndex = 0; // 其他产品的索引

            const newFlopList = [...flopList];
            newFlopList.map((item, index) => {
                if (index === targetIndex) {
                    item.title = targetPrize.isDisplayName ? targetPrize.prizeName : '';
                    item.imgUrl = targetPrize.isDisplayIcon ? targetPrize.iconUrl : '';
                    item.checked = true;
                    item.flip = true;
                    item.type = targetPrize.type;
                } else {
                    item.title = otherPrizes[otherPrizeIndex].isDisplayName ? otherPrizes[otherPrizeIndex].prizeName : '';
                    item.imgUrl = otherPrizes[otherPrizeIndex].isDisplayIcon ? otherPrizes[otherPrizeIndex].iconUrl : '';
                    otherPrizeIndex++;
                }
            });
            setFlopList(newFlopList);
            setTimeout(() => {
                const arr = [...flopList];
                arr.map((item) => {
                    item.flip = true;
                });
                setFlopList(arr);
                resolve(arr);
            }, 500);
        });

    const handleChoose = async (targetIndex: number) => {
        if (status !== 2) return;
        if (loading) return;
        setLoading(true);
        setAwardData(null);

        // check
        const { id: drawId, version } = drawInfo;
        try {
            const checkRes = await checkRewardDraw({ drawId, version }, locale, pathUrl);
            if (checkRes?.code !== '0') {
                setLoading(false);
                showErrorMessage(checkRes?.code, t);
                onCheckError?.();
                return;
            }
        } catch (e) {
            message.error(t('network_error'));
            setLoading(false);
            onCheckError?.();
            console.error('e', e);
            return;
        }

        // 获取奖项id
        const prizeRes = await rewardDraw({ drawId, version }, locale, pathUrl);
        if (prizeRes?.code === '0') {
            prizeRes.data && (await handleSettlement(prizeRes.data.awardsId, targetIndex));
            setLoading(false);
            if (prizeRes.data.prizeType === 'NOTHING') {
                setStatus(3);
                setAwardData(null);
            } else {
                setStatus(3);
                setAwardData(prizeRes.data);
            }
            // setStatus(3);
            // setAwardData(prizeRes.data);
        } else {
            // 找到未中奖的奖项
            const data = prizes.find((item) => item.type === 'NOTHING');
            data && (await handleSettlement(data.id, targetIndex));
            showErrorMessage(prizeRes?.code, t);
            setLoading(false);

            setStatus(3);
            setAwardData(null);
            // handleAccept();
            // onEnd?.(data);
        }
    };

    const handleStart = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_join',
            button_name: t('lucky_flop_start'),
        });
        if (!isLogin) {
            signupCookie?.({
                sector_name: t('lucky_flop_start'),
                entry_position: 6,
            });
            router.push(`/${locale}/login?redirect=${window.location.href}`);
            return;
        }
        setStatus(2);
        setAwardData(null);
        onStart();
        setTimeout(() => {
            const arr = [...flopList];
            arr.map((item) => {
                item.x = 0;
                item.y = 0;
            });
            setFlopList(arr);
        }, 0);
    };

    const handleAccept = () => {
        initFlopList();
        let obj = awardData;
        if (!obj) {
            obj = prizes.find((item) => item.type === 'NOTHING') as Prizes;
        }
        setTimeout(() => {
            setStatus(1);
            onEnd?.({ ...obj } || {});
        }, 500);
    };

    useEffect(() => {
        if (!prizes || status === 3) return;
        initFlopList();
    }, [prizes]);

    return (
        <div className={css.flop}>
            {status === 1 ? (
                <div className="flop_bg">
                    {/* <NextImage src={require(`@publicLocal/ecocredits/${isMobile ? 'h5' : 'pc'}/lucky-flopbg.jpg`)} alt="" /> */}
                    <div className="flop_tools">
                        <Button className="flop_btn" onClick={handleStart} disabled={disabled}>
                            {t('lucky_flop_start')}
                        </Button>
                        {!!drawInfo?.limitFlag && !isEu && (
                            <p className="flop_times">
                                {t.rich('remaining_number2', {
                                    code: () => <i className="flop_times_counts">{drawInfo?.available || 0}</i>,
                                })}
                            </p>
                        )}
                    </div>
                </div>
            ) : (
                <div className="flop_content">
                    <div className="flop_box">
                        {flopList &&
                            flopList.map((item, index) => (
                                <div
                                    className={`flop_item ${item.checked ? '' : 'disabled'}`}
                                    key={item.id}
                                    onClick={() => handleChoose(index)}
                                    style={{ transform: `translate(${item.x}px, ${item.y}px) ${item.flip ? 'rotateY(180deg)' : ''}` }}
                                >
                                    <div className="flop_front">
                                        {isEu ? (
                                            <EditorImg
                                                pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1715157018764/%E5%8D%A1%E7%89%87.png"
                                                alt=""
                                            />
                                        ) : (
                                            <NextImage src={require(`@publicLocal/ecocredits/pc/flopbg-second.png`)} alt="" loading="eager" />
                                        )}

                                        <p className="open">{t('lucky_flop_open')}</p>
                                    </div>
                                    <div className="flop_black">
                                        {isEu ? (
                                            <EditorImg
                                                pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1715157040605/%E5%8D%A1%E7%89%87-%E7%A9%BA.png"
                                                alt=""
                                            />
                                        ) : (
                                            <NextImage src={require(`@publicLocal/ecocredits/pc/flop-second.png`)} alt="" loading="eager" />
                                        )}

                                        <div className="flop_prize">
                                            {/* {item.checked && item.type !== 'NOTHING' && <p className="congratulate">{t('lucky_flop_congrat')}</p>} */}
                                            <h6 className="prize_title">{item.title}</h6>
                                            {item.imgUrl && (
                                                <div className="flop_prize_img">
                                                    <NextImage className="" src={item.imgUrl} alt={item.title} />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                    <div className="flop_tools">
                        {status === 3 && (
                            <Button className="flop_btn" onClick={handleAccept}>
                                {t('lucky_flop_get')}
                            </Button>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default FlopGame;
